export const getDefaultParamsMin = (rateRows) => getDefaultParams([(i, acc) => i < acc, (i, prev) => i?.maxSum > prev?.maxSum], rateRows);
export const getDefaultParamsMax = (rateRows = [], isNewClient = false) => getDefaultParams([(i, acc) => i > acc, (i, prev) => i?.minSum < prev?.minSum], rateRows?.filter((_) => isNewClient === Boolean(_?.isNewClient)));
const getDefaultParams = (comparators, rateRows) => {
    if (!rateRows?.length) {
        return undefined;
    }
    const rates = rateRows?.reduce((acc, i) => {
        if (comparators[0](i.rate, acc[0].rate)) {
            return [i];
        }
        else if (i.rate === acc[0].rate) {
            return [...acc, i];
        }
        return acc;
    }, [rateRows[0]]);
    if (rates.length > 1) {
        return rates.reduce((prev, i) => (comparators[1](i, prev) ? i : prev), rates[0]);
    }
    return rates[0];
};
//# sourceMappingURL=getDefaultParams.js.map